import { render, staticRenderFns } from "./Pacotes.vue?vue&type=template&id=f737b2b6&"
import script from "./Pacotes.vue?vue&type=script&lang=js&"
export * from "./Pacotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports